var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopilotLightBlueNoBgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16656 2.71319C7.72505 1.62917 9.27495 1.62917 9.83344 2.71319L9.87026 2.78468C10.2059 3.43605 10.9629 3.74964 11.6608 3.52635L11.7374 3.50184C12.8988 3.13023 13.9948 4.22618 13.6232 5.3876L13.5987 5.46419C13.3754 6.16208 13.689 6.91915 14.3403 7.25474L14.4118 7.29156C15.4958 7.85005 15.4958 9.39995 14.4118 9.95844L14.3403 9.99526C13.689 10.3309 13.3754 11.0879 13.5987 11.7858L13.6232 11.8624C13.9948 13.0238 12.8988 14.1198 11.7374 13.7482L11.6608 13.7237C10.9629 13.5004 10.2059 13.814 9.87026 14.4653L9.83344 14.5368C9.27495 15.6208 7.72505 15.6208 7.16656 14.5368L7.12974 14.4653C6.79415 13.814 6.03708 13.5004 5.33919 13.7237L5.2626 13.7482C4.10118 14.1198 3.00523 13.0238 3.37684 11.8624L3.40135 11.7858C3.62464 11.0879 3.31105 10.3309 2.65968 9.99526L2.58819 9.95844C1.50417 9.39995 1.50417 7.85005 2.58819 7.29156L2.65968 7.25474C3.31105 6.91915 3.62464 6.16208 3.40135 5.46419L3.37684 5.3876C3.00523 4.22618 4.10118 3.13023 5.2626 3.50184L5.33919 3.52635C6.03708 3.74964 6.79415 3.43605 7.12974 2.78468L7.16656 2.71319Z",
    stroke: "#5062F0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.49678,
    cy: 8.62412,
    rx: 3.4001,
    ry: 3.4,
    stroke: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotLightBlueNoBgOutline);
export default __webpack_public_path__ + "static/media/copilotLightBlueNoBgOutline.d384354b0d2f5d3ec25f8fbd76d1ddee.svg";
export { ForwardRef as ReactComponent };